import { legacy_createStore, combineReducers, applyMiddleware } from "redux";
import thunk from 'redux-thunk'
import { composeWithDevTools } from "redux-devtools-extension";
import profileReducer from "../Redux/Reducer/ProfileReducer";

const reducers = combineReducers({
    profile : profileReducer,
})
const initialState = {}
const middleware = [thunk]
const store = legacy_createStore(
    reducers,
    initialState,
    composeWithDevTools(applyMiddleware(...middleware))
)

export default store;

export type RootState = ReturnType<typeof store.getState>